// Which sidebar / bottom-nav menus each permission controls (see components/Layout/Layout.js).
// Shown in Users & Roles → Permissions so admins know that "Deny" hides the menu.
const menuPermissions = {
  "dashboard.view": ["Dashboard"],
  "profile.read": ["My Profile (members)"],
  "staff_profile.read": ["My Profile (staff)"],
  "id_cards.read": ["My ID", "Digital IDs"],
  "id_cards.manage": ["Card Templates"],
  "contributions.read": ["Contributions"],
  "loans.read": ["Loans"],
  "meetings.read": ["Meetings"],
  "elections.read": ["Elections"],
  "cases.read": ["Cases"],
  "cba.read": ["CBA Agreements"],
  "trainings.read": ["Trainings"],
  "engagement.read": ["Engagement"],
  "ai.use": ["AI Assistant"],
  "documents.read": ["Document Library"],
  "support.read": ["Help & Support"],
  "communications.read": ["Messages"],
  "members.read": ["Members"],
  "branches.read": ["Branches"],
  "finance.read": ["Accounting"],
  "requisitions.read": ["Requisition Register"],
  "reports.read": ["Reports"],
  "recruitment.read": ["Recruitment"],
  "screening.view": ["AI Screening"],
};

// Plain-language explanations for permissions that are not obvious from their name.
export const permissionDescriptions = {
  "recruitment.review": "Can view job applications and documents and change application status (one by one or in bulk). Also give recruitment.read so the Recruitment menu shows.",
  "recruitment.manage": "Full recruitment control: create, edit and delete vacancies, plus everything in recruitment.review.",
  "screening.view": "AI Screening: see the AI screening results, evidence and applicants' documents (read only). Shows the AI Screening menu.",
  "screening.review": "AI Screening: review results and change findings or points with a written reason. Also give screening.view so the menu shows.",
  "screening.manage": "AI Screening: start and stop screening runs, AI settings, approve criteria and give the second (final) approval. Also give screening.view so the menu shows.",
};

export default menuPermissions;
